//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "AppContentType",
  props: ["filter"],
  computed: {
		...mapGetters(["contentTypeChecked"]),
		selected() {
			return this.contentTypeChecked(this.filter.value)
		}
  },
  methods: {
		...mapMutations(["select_contentType"]),
		...mapActions(["load"]),
		select() {
			this.select_contentType(this.filter.value);
			this.load();
		}
  }
};
